import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useTableCellClassNames } from './utils/useTableCellClassNames';
import { TableCellRoot } from './style';
import { TABLE_CELL_CLASS_PREFIX } from './constants';
import { useTableCell } from './utils/useTableCell';
export var TableCell = forwardRef(function TableCell(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useComponentTheme(TABLE_CELL_CLASS_PREFIX);
  var classNameComponents = useTableCellClassNames(TABLE_CELL_CLASS_PREFIX, className);

  var _useTableCell = useTableCell(props),
      rootProps = _useTableCell.rootProps,
      Tag = _useTableCell.tag;

  return React.createElement(TableCellRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, {
      ref: ref
    }), children);
  });
});
TableCell.defaultProps = {
  stickyTop: false,
  stickyShadowVisible: true,
  stickyOffset: 0,
  isHeader: false,
  disabled: false,
  ellipsis: false,
  enableContentWordBreak: true,
  enableContentWrap: true
};